export default __webpack_public_path__ + "static/media/icon_menu.2856ab30.svg";